
'use strict';

var $carouselWrap = $('.testimonial-section');

$carouselWrap.on('afterChange', function (event, slick, activeSlide) { // Triggers on each slide change
    var $activeSlide = $(slick.$slides[activeSlide]); // Get the active slide element
    var $activeSlideWithVideo = $activeSlide.find('video'); // Find the video within the current slide

    $carouselWrap.find('video').each(function () { // Pause all videos
        this.pause();
    });

    if ($activeSlideWithVideo.length) { // Play the video if it exists
        $activeSlideWithVideo.get(0).play();
    }
});
let observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        let $slickEl = $(entry.target);

        if ($slickEl.hasClass('slick-initialized')) {
            if (entry.isIntersecting) {
                // Start autoplay when in view
                $slickEl.slick('slickPlay');

                // Play video if the active slide has one
                var slickObj = $slickEl.slick('getSlick');
                var $activeSlide = $(slickObj.$slides[slickObj.currentSlide]);
                var $activeVideo = $activeSlide.find('video');

                if ($activeVideo.length) {
                    $activeVideo.get(0).play();
                }
            } else {
                // Stop autoplay when out of view
                $slickEl.slick('slickPause');

                // Pause all videos inside this slick
                $slickEl.find('video').each(function () {
                    this.pause();
                });
            }
        }
    });
}, { threshold: 0.5 });

// Observe all slick sliders
$('.testimonial-section .experience-slides').each(function () {
    observer.observe(this);
});

/**
 * Updates the play/pause button icons based on the video's playback state.
 *
 * If `showPlay` is true → displays the play icon and hides the pause icon.
 * If `showPlay` is false → displays the pause icon and hides the play icon.
 *
 * @param {jQuery} $btn - The play button element containing `.playIcon` and `.pauseIcon`.
 * @param {boolean} showPlay - Whether to show the play icon (true) or the pause icon (false).
 */
function updatePlayIcons($btn, showPlay) {
    if (showPlay) {
        $btn.find('.playIcon').removeClass('d-none');
        $btn.find('.pauseIcon').addClass('d-none');
    } else {
        $btn.find('.playIcon').addClass('d-none');
        $btn.find('.pauseIcon').removeClass('d-none');
    }
}

/**
 * Updates the mute/unmute button icons based on the video's mute state.
 *
 * If `isMuted` is true → displays the mute icon and hides the unmute icon.
 * If `isMuted` is false → displays the unmute icon and hides the mute icon.
 *
 * @param {jQuery} $btn - The volume button element containing `.muteIcon` and `.unmuteIcon`.
 * @param {boolean} isMuted - Whether the video is currently muted (true) or unmuted (false).
 */
function updateVolumeIcons($btn, isMuted) {
    if (isMuted) {
        $btn.find('.muteIcon').removeClass('d-none');
        $btn.find('.unmuteIcon').addClass('d-none');
    } else {
        $btn.find('.muteIcon').addClass('d-none');
        $btn.find('.unmuteIcon').removeClass('d-none');
    }
}

/**
 * Binds video event listeners for all videos inside `.tm-video-container`.
 *
 * This function ensures that UI icons stay in sync with the video state,
 * even when playback is triggered programmatically (not through the user clicking).
 *
 * Currently, it listens for the `ended` event, and when the video finishes,
 * it automatically updates the corresponding play button icon to the "play" state.
 *
 * @function bindVideoEvents
 * @returns {void} This function does not return anything.
 */
function bindVideoEvents() {
    $('.tm-video-container video').each(function () {
        var $videoElement = $(this);
        $videoElement.on('ended', function () {
            var $container = $(this).closest('.tm-video-container');
            updatePlayIcons($container.find('.tm-play-btn'), true);
        });
    });
}

// Mute videos on load
$(document).ready(function () {
    $('.tm-video-container video').each(function () {
        this.muted = true;
    });

    bindVideoEvents();
});

// Toggle mute/unmute
$(document).on('click', '.tm-volume-button', function () {
    var $btn = $(this);
    var $container = $btn.closest('.tm-video-container');
    var $video = $container.find('video');

    if (!$video.length) return;

    var video = $video.get(0);
    video.muted = !video.muted;

    updateVolumeIcons($btn, video.muted);
});

// Toggle play/pause
$(document).on('click', '.tm-play-btn', function () {
    var $btn = $(this);
    var $container = $btn.closest('.tm-video-container');
    var $video = $container.find('video');

    if (!$video.length) return;

    var video = $video.get(0);

    if (video.paused || video.ended) {
        video.play();
        updatePlayIcons($btn, false); // show pause icon
    } else {
        video.pause();
        updatePlayIcons($btn, true); // show play icon
    }
});

$('.ckc-slick-carousel').on('afterChange', function () {
    $('.tm-video-container').each(function () {
        const $container = $(this);
        const $slide = $container.closest('.slick-slide');
        const video = $container.find('video').get(0);
        const $btn = $container.find('.tm-play-btn');

        // Skip if no video in this slide
        if (!video) return;

        // If slide is NOT active → stop + reset icons
        if (!$slide.hasClass('slick-active')) {
            video.pause();
            video.currentTime = 0;
            updatePlayIcons($btn, true); // show Play icon
        }
    });
});

/**
 * Observes the visibility of video elements within `.tm-video-container`.
 * Pauses and resets videos (and their play icons) when they are less than 20% visible in the viewport.
 */
function observeVideoVisibility() {
    const observerTm = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const $container = $(entry.target).closest('.tm-video-container');
            const video = $container.find('video').get(0);
            const $btn = $container.find('.tm-play-btn');

            if (!video) return;

            // If NOT visible → pause + reset icon
            if (!entry.isIntersecting) {
                video.pause();
                video.currentTime = 0;
                updatePlayIcons($btn, true);
            }
        });
    }, {
        threshold: 0.2 // 20% visibility required
    });

    $('.tm-video-container video').each(function () {
        observerTm.observe(this);
    });
}

observeVideoVisibility();
